/**
 * Convert tanh value output (-1.0 - 1.0) to win rate (0-100).
 * 
 * @param {*} value 
 */
export function toWinRate(value) {
  return (1.0 + value) / 2.0 * 100;
}

/**
 * Describe array - length, sum, mean, max and min.
 * 
 * @param {*} array 
 */
export function describe(array) {
  console.log(`length=${array.length || 0}`);
  console.log(`sum=${!array ? 0 : array.reduce((a, b) => a + b)}`);
  console.log(`mean=${!array.length ? 0 : array.reduce((a, b) => a + b) / array.length}`);
  console.log(`max=${Math.max.apply(null, array) || 0}`);
  console.log(`min=${Math.min.apply(null, array) || 0}`);
}

/**
 * Print first 10 items of the array.
 * 
 * @param {*} array 
 */
export function head(array) {
  if (!array) {
    console.warn('Empty array');
    return;
  }
  const size = Math.min(10, array.length);
  for (let i = 0; i < size; i++) {
    console.log(`[${i}] ${array[i]}`);
  }
}

/**
 * Print 10 sample items of the array.
 * 
 * @param {*} array 
 */
export function sample(array) {
  if (!array) {
    console.warn('Empty array');
    return;
  }
  const size = Math.min(10, array.length);
  for (let i = 0; i < array.length; i += Math.floor(array.length / size)) {
    console.log(`[${i}] ${array[i]}`);
  }
}

/**
 * Sleep for the specified milli seconds.
 */
export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
